import React, { useState } from 'react';
import { LockKeyholeIcon, XIcon } from 'lucide-react';
export function CookiePrivacyBanner() {
  const [visible, setVisible] = useState(true);
  const [preferencesOpen, setPreferencesOpen] = useState(false);
  if (!visible) return null;
  return <aside className="fixed inset-x-3 bottom-3 z-50 w-auto border border-[#C8D8CD] bg-[#F4F8F5] shadow-2xl sm:inset-x-auto sm:bottom-6 sm:right-6 sm:w-[min(34rem,calc(100%-3rem))]" aria-label="Privacy settings" data-id="element-77" data-mp="16wxgozv7kyn">
      <div className="p-4 sm:p-5" data-id="element-78" data-mp="3ilk6ai0hv0ng">
        <div className="flex items-start gap-3" data-id="element-79" data-mp="3ikintsh5fbvp">
          <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white text-[#008F82]" aria-hidden="true" data-id="element-80" data-mp="3ejqdevwjj0xu">
            <LockKeyholeIcon className="h-4 w-4" data-id="element-81" data-mp="39mgpxlspozcn" />
          </span>
          <div className="min-w-0 flex-1" data-id="element-82" data-mp="34lsrif25lg8e">
            <p className="text-sm font-bold text-[#1C1C1C]" data-id="element-83" data-mp="34nn9plm1iu8s">
              Your Privacy Matters
            </p>
            <p className="mt-1 text-xs leading-5 text-[#666]" data-id="element-84" data-mp="2zoska0tki7fp">
              We use cookie identifiers to track live neighborhood wait times
              and stock analytics securely. By exploring PharmacyPulse, you
              support healthcare data transparency.
            </p>
            {preferencesOpen && <p id="privacy-preferences-status" className="mt-3 rounded-sm bg-white px-3 py-2 text-xs text-[#008F82]" role="status" data-id="element-85" data-mp="2mvqqpm7fk0wi">
                Essential privacy preferences are active for this local demo.
              </p>}
          </div>
          <button type="button" onClick={() => setVisible(false)} className="grid h-9 w-9 shrink-0 place-items-center rounded-sm text-[#666] hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#008F82]" aria-label="Dismiss privacy notice" data-id="element-86" data-mp="30mdggov7qggg">
            <XIcon className="h-4 w-4" data-id="element-87" data-mp="1u8mjdakv7ahk" />
          </button>
        </div>
        <div className="mt-4 flex flex-wrap items-center gap-3 pl-12" data-id="element-88" data-mp="nknzfyo6kn6">
          <button type="button" onClick={() => setPreferencesOpen(!preferencesOpen)} className="px-1 py-2 text-xs font-semibold text-[#5B665E] hover:text-[#008F82] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#008F82]" aria-controls="privacy-preferences-status" aria-expanded={preferencesOpen} data-id="element-89" data-mp="3rv5g3hc47tbn">
            Manage Preferences
          </button>
          <button type="button" onClick={() => setVisible(false)} className="rounded-sm bg-[#008F82] px-4 py-2.5 text-xs font-semibold text-white hover:bg-[#006F65] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#008F82] focus-visible:ring-offset-2" data-id="element-90" data-mp="393me9dttulb7">
            Accept &amp; Continue
          </button>
        </div>
      </div>
    </aside>;
}